export function encodeBase64(string, options = {}) {
  let result = btoa(string)

  if (options.urlSafe) {
    result = result.replace(/\+/g, '-').replace(/\//g, '_').replace(/\=+$/, '')
  }

  return result
}

export function decodeBase64(string) {
  if (string.length % 4 !== 0) {
    string += ('===').slice(0, 4 - (string.length % 4))
  }

  string = string.replace(/-/g, '+').replace(/_/g, '/')

  return atob(string)
}

export function isBase64(string) {
  try {
    return !!decodeBase64(string)
  } catch(error) {
    return false
  }
}
